import template from './defa-timepicker.vue.html';

export const VueTimePickerComponent = {
	template,
	props: {
		value: {
			type: String
		},
		id: {
			type: String
		}
	},
	filters: {
		doubleDigit(number) {
			return '%02d'.format(number);
		}
	},
	computed: {
		isMobile() {
			return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test( navigator.userAgent );
		},
		hours: {
			get() {
				return parseInt(this.innerValue.split(':')[0]);
			},
			set(newValue) {
				this.setTime(newValue, this.minutes);
			}
		},
		minutes: {
			get() {
				return parseInt(this.innerValue.split(':')[1]);
			},
			set(newValue) {
				this.setTime(this.hours, newValue);
			}
		}
	},
	watch: {
		value(newValue) {
			if(newValue !== this.innerValue) {
				this.innerValue = newValue;
			}
		},
		open(opening) {
			if(opening) {
				window.addEventListener('click',this.closeOutside);
			} else {
				window.removeEventListener('click', this.closeOutside)
			}
		}
	},
	methods: {
		closeOutside(event) {
			if(!this.$el.contains(event.target)) {
				this.open = false;
			}
		},
		incrementHours() {
			this.hours = (this.hours + 1) % 24;
		},
		decrementHours() {
			this.hours = ((this.hours - 1) + 24) % 24
		},
		incrementMinutes() {
			let oldValue = this.minutes;
			this.minutes = (this.minutes + 1) % 60;
			if (oldValue > this.minutes) {
				this.incrementHours();
			}
		},

		decrementMinutes() {
			let oldValue = this.minutes;
			this.minutes = (this.minutes - 1 + 60) % 60;
			if (oldValue < this.minutes) {
				this.decrementHours();
			}
		},
		
		start(method) {
			method();
			
			let timeout;
			let interval;
			let stop = () => {
				window.removeEventListener('mouseup', stop);
				timeout && clearTimeout(timeout);
				interval && clearInterval(interval);
			};
			window.addEventListener('mouseup', stop);
			
			timeout = setTimeout(() => {
				interval = setInterval(method, 50);
			}, 700);
		},
		
		setTime(hours, minutes) {
			this.setInnerValue('%02d:%02d'.format(hours,minutes));
			
		},
		setInnerValue(value) {
			this.innerValue = value;
			this.$emit('input', this.innerValue)
		}
	},
	data() {
		return {
			interval: null,
			innerValue: this.value,
			open: false,
		}
	}
};


export const VueTimePickerPlugin = {
	install( Vue, options ) {
		Vue.component( 'defa-time-picker', VueTimePickerComponent );
	}
};